<p-dialog
  [(visible)]="display"
  header="{{ 'label.CustomerAgents' | translate }}"
  (onHide)="onCancel()"
  appendTo="body"
  modal="true"
  width="300"
>
  <div>
    <p-listbox
      [options]="customerAgents"
      [(ngModel)]="selectedCustomerAgents"
      multiple="true"
      checkbox="true"
    ></p-listbox>
  </div>
  <ng-template #footer>
    <p-button
      type="button"
      (click)="send()"
      label="{{ 'label.Send' | translate }}"
    ></p-button>
    <p-button
      type="button"
      (click)="onCancel()"
      label="{{ 'label.Cancel' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
